/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Types of thermal model.
 */
export enum ThermalModelType {
    NONE = 'None',
    ONE_DIMENSION = 'OneDimension',
    TWO_DIMENSION = 'TwoDimension',
}
